<script>
import Layout from '@layouts/main.vue'
import { dutyMethods, userMethods, dutyComputed } from '@state/helpers'
import dayjs from 'dayjs'

export default {
  page: {
    title: 'Savanorio papildomos valandos',
  },

  components: { Layout },

  data() {
    return {
      fullName: '',
      hours: '',
      notes: '',
      id: '',
      page: 1,
      perPage: 25,
    }
  },

  computed: {
    ...dutyComputed,

    userId() {
      return this.$route.params.id
    },
  },

  created() {
    this.viewUser(this.userId)
      .then(
        ({ first_name, last_name }) =>
          (this.fullName = `${first_name} ${last_name}`),
      )
      .catch(() => this.$router.push({ name: 'users' }))
    this.loadDutiesList()
  },

  methods: {
    ...userMethods,

    ...dutyMethods,

    loadDutiesList() {
      const { page, perPage } = this
      this.fetchAllDuties({
        page,
        perPage,
        user_id: this.userId,
        noshift: true,
      })
    },

    onSubmitForm() {
      if (!this.notes || !this.hours) {
        return
      }

      if (this.id) {
        this.updateDuty({
          id: this.id,
          user_id: this.userId,
          hours: this.hours,
          notes: this.notes,
        }).then(() => {
          this.id = null
          this.hours = ''
          this.notes = ''
          this.loadDutiesList()
        })
      } else {
        this.createDuty({
          date: dayjs().format('YYYY-MM-DD'),
          user_id: this.userId,
          hours: this.hours,
          notes: this.notes,
        }).then(() => {
          this.id = null
          this.hours = ''
          this.notes = ''
          this.loadDutiesList()
        })
      }
    },

    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD')
    },

    changeHourEntry(duty) {
      this.notes = duty.notes
      this.hours = duty.elapsed_hours
      this.id = duty.id
    },

    confirmHoursDelete(id) {
      if (confirm('Ar tikrai norite ištrinti įrašą?')) {
        this.deleteDuty({ userId: this.userId, id }).then(this.loadDutiesList)
      }
    },
  },
}
</script>

<template>
  <Layout>
    <base-page-title>
      <template v-slot:title>
        <h1 class="text-2xl font-bold">
          {{ fullName }}: papildomos valandos
        </h1>
      </template>
      <template v-slot:actions>
        <div>
          <base-btn
            class="lg:ml-2 py-2 px-4"
            @click="$router.push({ name: 'user-edit', params: { id: userId } })"
          >
            <font-awesome-icon :icon="['fas', 'undo']" class="mr-1" />
            Grįžti atgal
          </base-btn>
        </div>
      </template>
    </base-page-title>

    <form
      class="flex flex-row items-end mb-4 space-x-4 w-full"
      @submit.prevent="onSubmitForm"
    >
      <base-label-input
        v-model="hours"
        type="text"
        label="Pridėti val."
        required
        placeholder="2.00"
        @submit="onSubmitForm"
      />
      <base-label-input
        v-model="notes"
        type="text"
        label=" "
        placeholder="Už ką valandos skiriamos"
        class="w-full"
        @submit="onSubmitForm"
      />
    </form>

    <div class="-mx-8">
      <table v-if="duties && duties.length" class="table-auto w-full">
        <thead>
          <tr>
            <th class="hidden lg:table-cell">Data</th>
            <th class="text-left">Įrašas</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="duty in duties" :key="duty.id" class="border text-sm">
            <td class="w-24 hidden lg:table-cell">
              {{ formatDate(duty.date) }}
            </td>
            <td class="hidden lg:table-cell">
              <div class="cursor-pointer" @click="changeHourEntry(duty)">
                {{ duty.notes }} ({{ duty.elapsed_hours }} val.)
              </div>
            </td>
            <td class="w-32">
              <base-btn
                type="danger"
                class="ml-2 px-2 py-1"
                @click="confirmHoursDelete(duty.id)"
              >
                Pašalinti
              </base-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
</template>
